import { Component } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { getDisableClickAwayProps } from '@optimus-web/helpers';
import { getCurrentEnterpriseId } from '@mews-commander/core';
import { fetchNotifications } from '../actions/common';
import { subscribeNotificationUpdates, unsubscribeNotificationUpdates } from '../actions/subscriptions';
import { SystemNotificationsDropdown, MessageNotificationsDropdown } from './TopMenuDropdown';

interface Props {
    showMessageMenu?: string;
    fetchNotifications: $TSFixMeFunction;
    subscribeNotificationUpdates: $TSFixMeFunction;
    unsubscribeNotificationUpdates: $TSFixMeFunction;
}

class NotificationMenu extends Component<Props> {
    componentDidMount() {
        this.props.subscribeNotificationUpdates();
        this.props.fetchNotifications();
    }

    componentWillUnmount() {
        this.props.unsubscribeNotificationUpdates();
    }

    render() {
        return (
            <>
                <span {...getDisableClickAwayProps()}>
                    <SystemNotificationsDropdown />
                </span>
                {this.props.showMessageMenu && (
                    <span {...getDisableClickAwayProps()}>
                        <MessageNotificationsDropdown />
                    </span>
                )}
            </>
        );
    }
}

export default connect(
    createStructuredSelector({
        showMessageMenu: getCurrentEnterpriseId,
    }),
    {
        fetchNotifications,
        subscribeNotificationUpdates,
        unsubscribeNotificationUpdates,
    }
)(NotificationMenu);
